import React from "react";
import * as Lucide from "lucide-react";

export default function Icon({ name, className, size = 20 }) {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp className={className} size={size} strokeWidth={1.6} />;
}
